import { useShow } from "@refinedev/core";
import { Show, BooleanField } from "@refinedev/antd";
import { Typography } from "antd";

import { User } from "interfaces";

// The admin API only ever returns stored users, so the id is always there.
// The generated `User` has it optional because the schema it comes from is
// shared with the create and update shapes, and refine needs a definite key.
type UserRecord = User & { id: number };

const { Title, Text } = Typography;

export const UserShow: React.FC = () => {
  const { query, result: record } = useShow<UserRecord>();
  const { isLoading } = query;

    return (
    <Show isLoading={isLoading}>
      <Title level={5}>Email</Title>
      <Text>{record?.email}</Text>

      <Title level={5}>Full name</Title>
      <Text>{record?.full_name}</Text>

      <Title level={5}>Is Active</Title>
      <BooleanField value={record?.is_active} />

      <Title level={5}>Is Superuser</Title>
      <BooleanField value={record?.is_superuser} />
    </Show>
  );
};
